<template>
    <div>
        <!-- Première branche de l'arbre -->
        <GenericNodeView v-for="node in Root.Nodes" :key="node.Id" :Node="node" v-on="$listeners"/>
    </div>
</template>

<script lang="ts">

/** Composants Vue.js */
import { Prop,  ProvideReactive, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

/** Types personalisés */
import SelectModeEnum from '@/enums/SelectModeEnum';

/** Sous-composants */
import GenericNodeView from './GenericTree/GenericNodeView.vue';
import { GenericTree } from './GenericTree/GenericTreeClass';

/** Affiche une arborescence simple à partir d'un GenericTree */
@Component({
    components:{ 
       GenericNodeView
    },
})
export default class GenericTreeView extends Vue {
    
    /** 
     * Variant de couleur à appliquer sur le composant
     * @default secondary
     */
    @Prop()
    @ProvideReactive()
    public Variant!: string;

    /** Racine de l'arbre contenant les métadonnées de l'arbre (count, selected, ...) */
    @Prop()
    @ProvideReactive()
    public Root!: GenericTree;

    /** Détermine si l'on doit utiliser des icones bootstrap */
    @Prop({ default: false })
    @ProvideReactive()
    public UseBootstrapIcon!: boolean;

    /** 
     * Mode de selection
     * @returns {SelectModeEnum.Single|SelectModeEnum.MultiAdvanced|SelectModeEnum.MultiSimple}
     */
    @Prop()
    @ProvideReactive()
    public SelectMode!: SelectModeEnum;

}
</script>

<style scoped>
</style>